e.A = e.AccountSettings = {
	Messages : {},
	
	init : function(){
		this.Messages = new e.Messages();
		this.Messages.content_div = '#content-right-js';

		e.A.general_info.init();
		e.A.notification_settings.init();
		e.A.password.init();
		e.A.website_url.init();
		e.A.user_photo.init();
	}
};